<div class="d-flex flex-row align-items-center mb-3 ml-3 mr-3">
    <div class="h3">{{ 'integration_apps_hub_headline' | i18next }}</div>
    <div class="ml-auto bd-highlight">
        <button name="show-creation-editor" class="btn btn-outline-primary"
            [routerLink]="['/integration-apps', 'create']">{{ 'integration-apps-hub_create_new_app_btn' |
            i18next}}</button>
        <button name="show-marketplace" class="btn btn-outline-primary ml-3"
            [routerLink]="['/integration-apps', 'marketplace']">{{ 'integration_apps_button_marketplace' |
            i18next}}</button>
    </div>
</div>
<app-filter (searchFilterChanged)="filter($event)"
    [placeholder]="'integration_apps_search_hub_placeholder' | i18next"></app-filter>

<div class="h5 ml-3 mb-4"><b>{{ 'integration_apps_own_headline' | i18next }}</b></div>
@if (privateApps.length > 0) {
    <div class="row align-items-stretch mt-2">
        @for (app of privateApps; track app.uuid) {
        <app-integration-apps-card class="col-xs-12 col-md-6 col-lg-6 mb-3"
            [integrationApp]="app"></app-integration-apps-card>
        }
    </div>
}
@if (privateApps && privateApps.length === 0) {
    <app-no-content-message t="integration-apps-hub_no_own_apps"></app-no-content-message>
}

<div class="h5 mt-4 ml-3 mb-4"><b>{{ 'integration_apps_installed_headline' | i18next }}</b></div>
@if (installedAppsToDisplay.length > 0) {
    <div class="row">
        @for (app of installedAppsToDisplay; track app.slimIntegrationApp.uuid) {
        <app-integration-apps-card-long [integrationApp]="app"></app-integration-apps-card-long>
        }
    </div>
}
@if (installedAppsToDisplay && installedAppsToDisplay.length === 0) {
    <app-no-content-message t="integration-apps-hub_no_installed_apps"></app-no-content-message>
}